// Оплата мероприятия
function ajaxPaymentEvent(jqForm) {
    var dataToSend = 'kind=event&';

    trimFormFields(jqForm);
    dataToSend += jqForm.serialize();

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/payment/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                location = responseObj.result.json.url;
            }
            else {
                if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
            }
        },
    });
}


// Отправка запроса на получение формы оплаты регулярных занятий
function ajaxGetRegularLessonPaymentForm(id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken + '&group_id=' + id + '&action=get_payment_form';

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.body-cover').append(responseObj.result.html);
                $('input[name*="date_start"]').mask('00.00.0000');
                calculateEndSubscriptionDate(true);
                showPopUp('payment-regular-lesson');
            }
            else {
                if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
            }
        },
    });
}


// Отправка запроса на получение списка типов оплат на форме оплаты регулярных занятий
function ajaxGetRegularLessonPaymentTypes(groupId, learnerId) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken + '&group_id=' + groupId + '&learner_id=' + learnerId + '&action=get_payment_types';

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                var activeLabel = $('.payment-types-list label.active'),
                    index = $('.payment-types-list label').index(activeLabel);

                $('.payment-types-list').html(responseObj.result.html);
                $('.payment-types-list label').eq(index).trigger('click');

                if (index == 0) {
                    var newPaymentType = $('.payment-types-list label.active').find('input[name="payment_type"]').val();

                    ajaxGetRegularLessonPaymentLessons(groupId, learnerId, newPaymentType);
                }
            }
            else {
                if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
            }
        },
    });
}


// Отправка запроса на получение списка занятий на форме оплаты регулярных занятий
function ajaxGetRegularLessonPaymentLessons(groupId, learnerId, paymentType) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken
            + '&group_id=' + groupId
            + '&learner_id=' + learnerId
            + '&payment_type=' + paymentType
            + '&action=get_lessons';

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '',
        method: 'POST',
        async: false,

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                const isPaymentAvailable = responseObj.result.has_lessons;
                $('.body-cover-pop-up-wrapper.payment-regular-lesson.visible .js-select-lesson-container').html(responseObj.result.html);
                $('.body-cover-pop-up-wrapper.payment-regular-lesson.visible .submit-form').attr('disabled', !isPaymentAvailable);

                var lessonId = $('.lessons-list label.active').val();
                if ($('.lessons-list label[for="lesson-' + lessonId + '"]').length > 0) {
                    $('.lessons-list label[for="lesson-' + lessonId + '"] input').trigger('change');
                }
                else {
                    $('.lessons-list label').eq(0).find('input').trigger('change');
                }
            }
            else {
                if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
            }
        },
    });
}


// Проверка возможности покупки абонемента в указанный период действия
function ajaxCheckPaymentSubscriptionPeriod(groupId, learnerId, subscriptionId, dateStart, isFixed) {
    var isFixed = isFixed ? isFixed : false,
        csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken + '&group_id=' + groupId + '&learner_id=' + learnerId + '&subscription_id=' + subscriptionId + '&date_start=' + dateStart + '&action=check_subscription_period';

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                if (isFixed) $('.fixed-subscription-period-container .check-amount-container').addClass('success').removeClass('error invisible').html(responseObj.result.json.message);
                else $('.js-subscription-period .check-amount-container').addClass('success').removeClass('error invisible').html(responseObj.result.json.message);
            }
            else {
                if (responseObj.error.message) showNotification(responseObj.error.message, 'error');

                if (responseObj.error.json) {
                    if (isFixed) $('.fixed-subscription-period-container .check-amount-container').addClass('error').removeClass('success invisible').html(responseObj.error.json.message);
                    else $('.subscription-period-container .check-amount-container').addClass('error').removeClass('success invisible').html(responseObj.error.json.message);
                }
            }
        },
    });
}


// Оплата регулярных занятий
function ajaxPaymentRegularLesson(jqForm) {
    var dataToSend = 'kind=regular_lesson&';

    trimFormFields(jqForm);

    dataToSend += jqForm.serialize();

    $.ajax({
        data: dataToSend,
        url: '/payment/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            if (responseObj.status == true) {
                location = responseObj.result.json.url;
            }
            else {
                if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
            }
        },
    });
}